import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { GlobeAmericasIcon } from '@heroicons/react/20/solid'
import { useLocalStorage } from 'hooks/useLocalStorageState'
import { useTranslation } from 'next-i18next'
import { LANGUAGE_KEY, LANGS } from 'utils/constants'
import { rouna, rounaDisplay, rounaMono } from 'utils/fonts'
import { memo } from 'react'

const LanguageSwitch = memo(function LanguageSwitch() {
  const [, setSavedLanguage] = useLocalStorage(LANGUAGE_KEY)
  const { t } = useTranslation(['settings'])

  return (
    <Menu>
      <MenuButton>
        <div className="default-transition flex size-8 items-center justify-center rounded-full bg-th-bkg-3 md:hover:bg-th-bkg-4">
          <GlobeAmericasIcon className="size-5 text-th-fgd-1" />
        </div>
      </MenuButton>
      <MenuItems
        className={`${rounaDisplay.variable} ${rouna.variable} ${rounaMono.variable} mt-3 space-y-2 rounded-lg bg-th-bkg-2 p-4 focus:outline-none`}
        anchor="bottom"
      >
        {LANGS.map((lang) => (
          <MenuItem key={lang.locale}>
            <button
              onClick={() => setSavedLanguage(lang.locale)}
              className="w-full text-left font-body text-th-fgd-1 hover:text-th-fgd-2"
            >
              {t(lang.name)}
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  )
})

export default LanguageSwitch
